import { PocButton } from 'commons/components/components-wrapper';
import { TFunction } from 'core/i18n/i18n';
import React from 'react';
import {
    getFilteredFlatOptions,
    getFilteredNestedChildren,
    getFilteredNestedOptions,
    getSelectAllCandidates,
} from 'commons/components/searchable-dropdown/searchable-dropdown.business';
import {
    NestedSelectableOptions,
    SelectableOptions,
} from 'commons/components/searchable-dropdown/searchable-dropdown.type';

export const SearchableDropdownFooter: React.FC<{
    value: string[];
    secondaryValue?: string[];
    isNestedList: boolean;
    disableEmptyGroups?: boolean;
    options: SelectableOptions[] | NestedSelectableOptions[];
    filter: string;
    numberSelectedOptions?: number;
    setVisible: React.Dispatch<React.SetStateAction<boolean>>;
    onApplySelection: (value: string[]) => void;
    applyDisabled?: boolean;
    onValueChange: (value: string[]) => void;
    t: TFunction;
    setFilter: (newValue: string) => void;
}> = (props) => {
    const {
        value = [],
        secondaryValue,
        isNestedList,
        disableEmptyGroups = false,
        options,
        filter,
        numberSelectedOptions,
        setVisible,
        onApplySelection,
        applyDisabled = false,
        onValueChange,
        t,
        setFilter,
    } = props;

    let filteredOptions = [];

    if (isNestedList) {
        filteredOptions = disableEmptyGroups
            ? getFilteredNestedChildren(options as NestedSelectableOptions[], filter)
            : getFilteredNestedOptions(options as NestedSelectableOptions[], filter);
    } else {
        filteredOptions = getFilteredFlatOptions(options, filter);
    }

    const getSelectedFilteredOptions = () => filteredOptions.filter((op) => value?.includes(op.id));
    const selectedFilteredOptions = getSelectedFilteredOptions();
    const selectAllCandidates = getSelectAllCandidates(filteredOptions);

    const handleOnApply = () => {
        setVisible(false);
        setFilter('');
        onApplySelection(value);
    };

    return (
        <div className="footer">
            <PocButton
                data-testid="searchable-dropdown-select-all"
                variant="tertiary"
                size="medium"
                disabled={!selectedFilteredOptions.length && !selectAllCandidates.length}
                onClick={() => {
                    if (selectedFilteredOptions.length) {
                        onValueChange(value.filter((v) => filteredOptions.every((op) => op.id !== v)));
                    } else {
                        onValueChange([...value, ...selectAllCandidates.map((option) => option.id)]);
                    }
                }}
            >
                {selectedFilteredOptions.length
                    ? t(`commons.components.searchable-dropdown.locations.deselect-all`)
                    : t(`commons.components.searchable-dropdown.locations.select-all`)}
            </PocButton>
            <PocButton
                data-testid="searchable-dropdown-apply"
                variant="primary"
                size="medium"
                onClick={handleOnApply}
                disabled={(!value.length && !secondaryValue?.length) || applyDisabled}
            >
                {numberSelectedOptions
                    ? t('commons.components.searchable-dropdown.footer.apply.button.number', {
                          number: numberSelectedOptions,
                      })
                    : t('commons.components.searchable-dropdown.footer.apply.button')}
            </PocButton>
        </div>
    );
};
